import api from '../../plugins/api';

// GET /crm/cars/findByVin?query= â Ð¼Ð°ÑÐ¸Ð½Ñ, Ñ ÐºÐ¾ÑÐ¾ÑÑÑ VIN ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ñ Ð²Ð²ÐµÐ´ÑÐ½Ð½ÑÐµ Ð·Ð½Ð°ÐºÐ¸ (Ð¾Ñ 5).
// ÐÑÐ²ÐµÑ: [{ id, vin, mark, model, issueYear, color, price, used }], Ð»ÑÑÑÐ¸Ðµ ÑÐ¾Ð²Ð¿Ð°Ð´ÐµÐ½Ð¸Ñ Ð¿ÐµÑÐ²ÑÐ¼Ð¸.
const findByVin = (query) => {
  return api.get('/api/crm/cars/findByVin', { query });
};

export default findByVin;
